// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_t-0";
export var skeletonCard = "_t-1";